// package dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import GuestGroupRow from './GuestGroupRow';
import GuestsHeader from './GuestsHeader';
import featureFlag from '../../../../util/featureFlags';

const isFlagGuestListMobileFix = featureFlag.get('flagGuestListMobileFix');

// must be a class component for sticky header to work properly
class GuestsTable extends Component { // eslint-disable-line
  render() {
    const {
      headerStyle,
      checkAllRows,
      checkedAllRows,
      onToggleSort,
      sortByNameAsc,
      filteredIds,
      guestGroups,
      editGuestModalOpen,
      selectedGuestGroupId,
      onToggleInvited,
      onEditGuestGroup,
      onDeleteGuestGroups,
      wedding,
      onGuestMessage,
      checkedRows,
      checkRow,
      onSelectGuestGroup,
      onRequestMissingInfo,
      tableId,
    } = this.props;

    return (
      <table
        className={`table guest-table-v2 table-fixed-header-round round-bottom ${
          isFlagGuestListMobileFix ? 'guests-list__table' : ''
        }`}
        id={tableId}
      >
        <GuestsHeader
          checkAllRows={checkAllRows}
          checkedAllRows={checkedAllRows}
          onToggleSort={onToggleSort}
          sortByNameAsc={sortByNameAsc}
          style={headerStyle}
        />
        <tbody className="guests-list__tbody">
          {filteredIds.map(guestGroupId => (
            <GuestGroupRow
              key={guestGroupId}
              guestGroup={guestGroups[guestGroupId]}
              modalOpen={editGuestModalOpen}
              isActive={guestGroupId === selectedGuestGroupId}
              onToggleInvited={onToggleInvited}
              onEditGuestGroup={onEditGuestGroup}
              onDeleteGuestGroups={onDeleteGuestGroups}
              wedding={wedding}
              onGuestMessage={onGuestMessage}
              isRowChecked={_.includes(checkedRows, guestGroupId)}
              onRowCheck={checkRow}
              onSelectGuestGroup={onSelectGuestGroup}
              onRequestMissingInfo={onRequestMissingInfo}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

GuestsTable.defaults = {
  headerStyle: {},
  selectedGuestGroupId: null,
};

GuestsTable.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  editGuestModalOpen: PropTypes.bool.isRequired,
  selectedGuestGroupId: PropTypes.number,
  filteredIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  guestGroups: PropTypes.shape({}).isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  checkRow: PropTypes.func.isRequired,
  checkAllRows: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  onRequestMissingInfo: PropTypes.func.isRequired,
  onToggleInvited: PropTypes.func.isRequired,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  onGuestMessage: PropTypes.func.isRequired,
  wedding: PropTypes.shape({}).isRequired,
  tableId: PropTypes.string,
};

export default GuestsTable;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/directoryEntities/GuestsTable.jsx